import { ReactElement } from 'react';

import { AdamedExpertConsent, AdamedExpertConsentQuery } from '@dreryk/egabinet-adamed-expert-frontend-api';
import { CurrentPractitionerQuery, PractitionerDetails } from '@dreryk/egabinet-personnel-frontend-api';

import { useCqrsGet, useCqrsSearch } from '@dreryk/command-query-react-common';
import { commonTranslationKeys } from '@dreryk/react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';

import { translationKeys } from './translations';

type AdamedExpertRegisterModalLoaderRenderProps = Pick<
   PractitionerDetails,
   'emailAddress' | 'medicalLicenceNumber' | 'phoneNumber'
> & {
   consents: AdamedExpertConsent[];
};

type AdamedExpertRegisterModalLoaderProps = {
   children: (renderProps: AdamedExpertRegisterModalLoaderRenderProps) => ReactElement;
};

export const AdamedExpertRegisterModalLoader = (props: AdamedExpertRegisterModalLoaderProps): ReactElement => {
   const {
      data: practitionerDetails,
      loading: practitionerDetailsLoading,
      error: practitionerDetailsError,
   } = useCqrsGet<PractitionerDetails>(() => new CurrentPractitionerQuery());

   const {
      data: adamedExpertConsents,
      loading: adamedExpertConsentsLoading,
      error: adamedExpertConsentsError,
   } = useCqrsSearch<AdamedExpertConsent>(() => new AdamedExpertConsentQuery());

   if (practitionerDetailsLoading || adamedExpertConsentsLoading) {
      return <LoaderSpinner />;
   }

   if (adamedExpertConsentsError) {
      return (
         <Message
            testId={'adamedExpertFetchError'}
            type={MessageType.NEGATIVE}
            label={translationKeys.modal.fetchError}
            displayIndicator
         />
      );
   }
   if (practitionerDetailsError) {
      return (
         <Message
            testId={'practitionerDetailsError'}
            type={MessageType.NEGATIVE}
            label={commonTranslationKeys.unexpectedErrorHasOccurred}
            displayIndicator
         />
      );
   }
   return props.children({
      emailAddress: practitionerDetails.emailAddress,
      medicalLicenceNumber: practitionerDetails.medicalLicenceNumber,
      consents: adamedExpertConsents,
   });
};
